import { gql } from '@apollo/client';

export const FUNCTIONAL_TITLE_GRAPHQL = gql`
    query {
        __type(name: "FunctionalTitle") {
            enumValues {
                name
                description
            }
        }
    }
`;
